import React from 'react';
import classnames from 'classnames';
import Tooltip from '../Tooltip';
import { disabledCountries } from '../../../utils'

import './styles.css';

export default class SimpleDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showOptions: false,
      showTooltip: false
    }
  }

  handleClick = (event) => {
    this.setState(prevState => { return { showOptions: !prevState.showOptions } });
  }

  handleBlur = (event) => {
    if (this.props._onBlur) {
      this.props._onBlur(event);
    }

    this.setState({ showOptions: false });
  }

  toggleTooltip = () => {
    var selector = `[data-tooltip=${this.props.tooltipId}]`
    document.querySelectorAll(selector)[0].setAttribute("aria-expanded", !this.state.showTooltip)
    this.setState({
      showTooltip: !this.state.showTooltip
    })
  }

  toggleTooltiponEnter = (event) => {
    if (event.keyCode === 27) {
      var selector = `[data-tooltip=${this.props.tooltipId}]`
      document.querySelectorAll(selector)[0].setAttribute("aria-expanded", false)
      this.setState({
        showTooltip: false
      })
    }
  }

  getDropDownValue = (value = '', showDefault) => {
    if (showDefault && (this.props.value === undefined || this.props.value === "")) {
      return "Please select"
    } else {
      return value
    }
  }

  render() {
    if (document.getElementById('holidayAdjustmentOptionField') !== null) {
      if (this.props.name === "frequencyType" && (this.props.value === undefined ||
        this.props.value === "urn:hsbc:cmb:gdocs:products:taxonomies:frequency:daily")) {
        document.getElementById('holidayAdjustmentOptionField').classList.add('noDisplay');
      }
    }

    let chevronCss = classnames('icon', {
      "icon-chevron-up-small": this.state.showOptions === true,
      "icon-chevron-down-small": this.state.showOptions === false
    });

    let options = [];
    if (this.props.mode === 'aem') {
      options = this.props.options.map((item) => {
        let splitOptions = item.split("=");
        return {
          id: splitOptions[0],
          value: splitOptions[1]
        };
      });
    } else {
      options = this.props.options;
    }

    let simpleDropdownCss = classnames('gdocs-simple-dropdown-container', this.props.bsClass, {
      'disabled': (this.props.disabled === true || this.props.disabled === "true")
    });

    return (
      <div className={simpleDropdownCss}>
        <div className="dropdown-arrow-chevron">
          <span className="vertical-line">|</span>
          <span className={chevronCss}></span>
        </div>
        <select
          className="gdocs-simple-dropdown"
          id={this.props.id}
          aria-describedby={this.props.ariadescribedby}
          name={this.props.name}
          onClick={this.handleClick}
          onChange={this.props._onChange}
          onBlur={this.handleBlur}
          value={this.getDropDownValue(this.props.value, this.props.showPleaseSelectOption)}
          disabled={this.props.disabled}>
          {
            this.props.showPleaseSelectOption ?
              <option
                value="Please select" disabled={!this.props.allowDefaultSelection}>
                {this.props.defaultValue}
              </option>
              : null
          }
          {
            options && options.map((item, index) => (
              <option
                key={this.props.id ? this.props.id + "-" + index : "dropdown-" + index}
                value={item[this.props.valueSelector || 'id']}
                disabled={(disabledCountries.indexOf(item.name) >= 0) || (this.props.disabledOptions &&
                  this.props.disabledOptions[index] === item[this.props.valueSelector || 'id'])}
                className={
                  classnames((disabledCountries.indexOf(item.name) >= 0) ? 'gdocs-dropdown-value-disabled ' : '',
                    (disabledCountries.indexOf(item.name) >= 0) || (this.props.disabledOptions &&
                      this.props.disabledOptions[index] === item[this.props.valueSelector || 'id']) ? "disabled" : "")
                }
              >
                {item[this.props.optionTextSelector || 'value']}
              </option>
            ))
          }
        </select>
        {
          (this.props.tooltipText !== undefined && this.props.tooltipText !== "")
            ? <button
              className="icon icon-circle-help gdocs-valign-middle gdocs-mleft-5 hintText-icon tooltip-simple-dropdown-hint"
              data-tooltip={this.props.tooltipId}
              onMouseEnter={this.toggleTooltip}
              onMouseLeave={this.toggleTooltip}
              onClick={this.toggleTooltip}
              onKeyUp={(event) => this.toggleTooltiponEnter(event)}
              aria-label={`Additional Information on ${this.props.name}`}
              aria-expanded="false"
              aria-describedby={`${this.props.tooltipId}tooltip`}
            >
            </button>
            : ''
        }
        <Tooltip
          active={this.state.showTooltip}
          position="right"
          arrow="center"
          parent={this.props.tooltipId}
        >
          <div className="tooltip-content-hintText" >
            <span role="status" id={`${this.props.tooltipId}tooltip`}>{this.props.tooltipText}</span>
          </div>
        </Tooltip>
      </div >
    )
  }
}


SimpleDropdown.defaultProps = {
  showPleaseSelectOption: true,
  defaultValue: 'Please Select'
}



// WEBPACK FOOTER //
// ./src/components/common/SimpleDropdown/index.js